/**
 * Footer menu accordions.
 * Menus collapse on mobile and remain fully visible on larger screens.
 */
(function() {
  'use strict';

  var existingController = window.themeFooterAccordion;
  if (existingController) {
    existingController.init();
    return;
  }

  var mobileMedia = window.matchMedia('(max-width: 767px)');

  function setMenuState(toggle, expanded) {
    var contentId = toggle.getAttribute('aria-controls');
    var content = contentId ? document.getElementById(contentId) : null;

    toggle.setAttribute('aria-expanded', String(expanded));
    if (!content) return;

    content.hidden = !expanded;
    content.classList.toggle('is-open', expanded);
  }

  function syncFooter(footer) {
    var toggles = footer.querySelectorAll('.js-footer-accordion-toggle');

    toggles.forEach(function(toggle) {
      if (mobileMedia.matches) {
        toggle.removeAttribute('tabindex');
        setMenuState(toggle, false);
      } else {
        toggle.setAttribute('tabindex', '-1');
        setMenuState(toggle, true);
      }
    });
  }

  function initFooter(footer) {
    if (footer.dataset.footerAccordionInitialized === 'true') {
      syncFooter(footer);
      return;
    }

    footer.dataset.footerAccordionInitialized = 'true';
    syncFooter(footer);

    footer.addEventListener('click', function(event) {
      var toggle = event.target.closest('.js-footer-accordion-toggle');
      if (!toggle || !footer.contains(toggle) || !mobileMedia.matches) return;

      var wasExpanded = toggle.getAttribute('aria-expanded') === 'true';
      footer.querySelectorAll('.js-footer-accordion-toggle').forEach(function(otherToggle) {
        if (otherToggle !== toggle) setMenuState(otherToggle, false);
      });
      setMenuState(toggle, !wasExpanded);
    });
  }

  function init() {
    document.querySelectorAll('[data-section-type="footer-section"]').forEach(initFooter);
  }

  window.themeFooterAccordion = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', init);
  } else {
    mobileMedia.addListener(init);
  }
})();
